define('models/PostcodeCollection',['underscore','ObjectCollection','LocalStorage','models/PostcodeModel','string'],function (_,ObjectCollection,LocalStorage,PostcodeModel,S) {
    //
    // Collection Postcode
    //

    var PostcodeCollectionPrototype = {

        name:'PostcodeCollection',
        route:'apiPostcodeCollection',
        model:PostcodeModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(collection,arguments);
            //
            collection.on('sync',collection.buildLocalitySimplification,collection);
            //
        },
        buildLocalitySimplification:function(){
            //
            // fabrique l'expression régulière pour la recherche de localité
            //
            var self = this, patterns = {}, exp = '';
            self.each(function(postcode){
                var simplification = postcode.getLocalitySimplification(true);
                _(simplification).each(function(word){
                    var simplificationPattern = '('+word+')';
                    patterns[word] = simplificationPattern;
                });
            });
            _(patterns).each(function(v,k){
                exp+=v+'|';
            });
            exp = exp.slice(0,-1);
            self.localitySimplificationExp = new RegExp(exp,'i');
        },
        isLocalityMatching:function(locality){
            var formatedLocality = formatLocality(locality),
                localitySimplificationExp = this.localitySimplificationExp;
            // si les codes ne sont pas encore disponible, on concidère tout comme vrai.
            if(!localitySimplificationExp) return true;

            return !!formatedLocality.match(localitySimplificationExp);
        },
        filterByLocalityName:function(locality){
            if(!locality) return [];
            var formatedLocality = formatLocality(locality);
            return this.filter(function(postcode){
                return postcode.testFormatedLocality(formatedLocality);
            });
        },
        getByLatLng:function(lat,lng){
            // attention cette méthode retourne le premier résultat valide
            return this.find(function(postcode){
                return postcode.isLatLngMatching(lat,lng);
            });
        },
        getDistrict:function(id_district){
            var district = false;
            this.each(function(postcode){
                if(!district && postcode.hasDistricts()){
                    district = postcode.getDistrict(id_district);
                }
            });
            return district;
        },
        getByLinkSEO: function(link_rewrite_seo)  {
            return this.findWhere({link_rewrite_seo: link_rewrite_seo})
        }
    }


    function formatLocality(locality){
        return S(locality.toLowerCase()).latinise().stripPunctuation();
    }

    var PostcodeCollection = ObjectCollection.extend(LocalStorage).extend(PostcodeCollectionPrototype);

    return PostcodeCollection;
});
